import BillInfo from './BillInfo';
//创建单据号

/**
 * @namespace BillHeadInfo
*/

/**
 * HeadProps参数说明
 * @memberof BillHeadInfo
 * @typedef HeadProps
 * @property {string} title 标题
 * @property {string} billCode 单据号
 * @property {boolean} showBillCode=true 是否显示单据号
 * @property {boolean} showPageIcon=true 是否显示图标
 * @property {function} backBtnClick 返回按钮点击事件函数
 * @property {function} titleClick 标题点击事件函数
*/

/**
 * 创建标题区
 * @memberof BillHeadInfo
 * @param {HeadProps} props
 */
export function createBillHeadInfo(events) {
    return (
        <BillInfo
            getThis={(_this) => {
                this.myBillInfo = _this;
            }}
            events={events}
            output={this.output}
            rootprops={this.props}
            pageScope={this}
        />
    );
}